// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__gaMR9","active":"downloadDropdown_active__Nyifs"};